var React = require('react');

function StreamlineLine37MusicNote3 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},React.createElement("path",{"d":"M12.5 18.5c0 1.5-1.342 3-3 3-1.656 0-3-1.343-3-3 0-1.656 1.344-3 3-3h3v3zM12.5 15.5v-14c0 1.243.34 2.227 1.5 3 4.804 3.203 2.809 7.378 1.613 10.5"})),React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":1})]);
}

StreamlineLine37MusicNote3.displayName = "StreamlineLine37MusicNote3";

StreamlineLine37MusicNote3.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine37MusicNote3;

StreamlineLine37MusicNote3.default = StreamlineLine37MusicNote3;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-37-music-note-3.svg
// module id = 774
// module chunks = 0